<template>
  <el-input
    placeholder="Keyword search"
    ref="keyword_filter"
    v-model="keyword"
    @change="change">
    <template #suffix>
      <el-icon @click="clearKeyword">
        <component :is="keyword ? 'circle-close' : 'search'"></component>
      </el-icon>
    </template>
  </el-input>
</template>

<script>
  import Mousetrap from 'mousetrap'

  export default {
    name: 'keywordFilter',
    props: {
      properties: Object
    },
    data () {
      return {
        keyword: '',
        searchTimeout: null,
        mousetrap: null
      }
    },
    methods: {
      change () {
        if (typeof this.properties.sync === 'function') {
          this.properties.sync(this.keyword)
        }
      },
      clearKeyword () {
        this.keyword = ''
        this.$store.dispatch('unsetFilter', 'search')
        if (typeof this.properties.clear === 'function') {
          this.properties.clear(['keyword'])
        }
      },
      /**
       * Bind filter application (search) to enter key
       */
      bindMousetrap () {
        if (this.$refs && this.$refs[`keyword_filter`] && this.$refs['keyword_filter'].$refs.input) {
          this.mousetrap = new Mousetrap(this.$refs['keyword_filter'].$refs.input)
          // Mousetrap's 'enter' is a keydown handler that fires BEFORE el-input's native `change`
          // event. If we only called apply() here, the first Enter would search with the parent's
          // stale keyword (sync hadn't run yet) and the value only "took" on the second Enter. Sync
          // the current keyword to the parent first, then apply, so a single Enter searches it.
          this.mousetrap.bind('enter', () => {
            this.change()
            this.properties.apply()
          })
        }
      }
    },
    mounted () {
      this.bindMousetrap()
    },
    beforeUnmount () {
      this.mousetrap.unbind('enter')
    }
  }
</script>
